module.exports = __webpack_public_path__ + "static/media/design-discounted.8845b81c.png";